<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useEditions } from '@/composables/useEditions'
import SwitchPolicyPanel from '@/components/organizer/SwitchPolicyPanel.vue'

const route = useRoute()
const eventSlug = route.params['eventSlug'] as string
const editionSlug = route.params['editionSlug'] as string

const { edition, fetchEdition } = useEditions()

onMounted(async () => {
  if (!edition.value || edition.value.slug !== editionSlug) {
    await fetchEdition(eventSlug, editionSlug)
  }
})
</script>

<template>
  <SwitchPolicyPanel v-if="edition" :edition-id="edition.id" :dirty-key="(route.name as string)" />
</template>
